var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "legalRule", "data-role": "page" } }, [
    _c(
      "div",
      { staticClass: "legalRule-content", attrs: { "data-position": "fixed" } },
      [
        _c("div", { staticClass: "detailWrap" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "detail-c" }, [
            _c(
              "ul",
              { staticClass: "collapse-ul-list rule-list" },
              _vm._l(_vm.Rules, function(rule, rule_ind) {
                return _c(
                  "li",
                  {
                    key: rule_ind,
                    attrs: { id: "Wrap" + rule_ind },
                    on: {
                      click: function($event) {
                        _vm.openWrap(rule_ind)
                      }
                    }
                  },
                  [
                    _c("a", { staticClass: "title" }, [
                      _c("div", { staticClass: "info" }, [
                        _c("h4", [_vm._v(_vm._s(rule.rule_name))])
                      ]),
                      _vm._v(" "),
                      _c("i", { staticClass: "icon-dropdown triggerIcon" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "triggerWrap" }, [
                      _c(
                        "ul",
                        { staticClass: "collapse-ul-sublist" },
                        _vm._l(rule.ruleList, function(cont, cont_ind) {
                          return _c(
                            "li",
                            { key: cont_ind },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "legalRuleDetail",
                                      params: { id: cont.rule_id }
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(cont.rule_name))]
                              )
                            ],
                            1
                          )
                        })
                      )
                    ])
                  ]
                )
              })
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-h" }, [
      _c("h3", [_vm._v("公寓大廈管理條例")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detailWrap extraWrap" }, [
      _c("div", { staticClass: "detail-h" }, [_c("h3", [_vm._v("法律沿革")])]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-c" }, [
        _c("ul", { attrs: { id: "" } }, [
          _c("li", [
            _vm._v(
              "中華民國 84年6月28日總統華總(一)義字第4316號令制定公布全文52條"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "中華民國89年4月26日總統華總一義字第8900104430號令修正公布第2條條文"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "中華民國92年12月31日總統華總一義字第09200243911號令修正公布全文6 3條，並自公布日施行"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "中華民國95年1月18日總統華總一義字第09500005871號令修正公布第29條；增訂第59條之1條文(中華民國101年6月25日行政院院臺規字第101013 4960 號公告第17條第1項所列屬「財政部」之權責事項，經行政院公告 自93年7月1日起變更為「行政院金融監督管理委員會」管轄，自101年7 月1日起改由「金融監督管理委員會」管轄)"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "中華民國102年5月8日總統華總一義字第 10200082711號令修正公布第8條 、第27條條文"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "中華民國105年11月16日總統華總一義字第10500140111號令修正公布第 8 條及第18條條文"
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73857915", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73857915","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/legalRule.vue
// module id = null
// module chunks = 